import i18n from "@i18n";

const {t} = i18n.global;

export default [
    {
        path: "/home",
        name: "home",
        component: () => import("@views/Home.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.home"),
        },
    },
   
    {
        path: "/analytics",
        name: "analytics",
        component: () => import("@views/analytics/Index.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.analytics"),
        },
    },
    {
        path: "/search",
        name: "search",
        component: () => import("@views/search/Search.vue"),
        keepAlive: true,
        meta: {
            requiresAuth: true,

            // transition: 'bounce',
            title: t("sidebar.search"),
        },
    },
    {
        path: "/projects",
        name: "projects",
        component: () => import("@views/projects/List.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.projects"),
        },
    },
    {
        path: "/projects/:id",
        name: "projects.view",
        component: () => import("@views/projects/View.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.projects"),
        },
    },
    {
        path: "/documents",
        name: "documents",
        component: () => import("@views/documents/List.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.documents"),
        },
    },
    {
        path: "/documents/category/:slug?",
        name: "documents.category",
        component: () => import("@views/documents/List.vue"),
        meta: {
            requiresAuth: true,
            title: t("sidebar.documents"),
        },
    },
    {
        path: "/documents/:id",
        name: "documents.view",
        component: () => import("@views/documents/View.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.documents"),
        },
    },
    {
        path: "my-knowledge",
        name: "my.knowledge",
        component: () => import("@views/myKnowledge.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.myKnowledge"),
        },
    },
    {
        path: "requests",
        name: "requests",
        component: () => import("@views/requests/List.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.Requests"),
        },
    },
    {
        path: "projects-requests",
        name: "projects-requests",
        component: () => import("@views/projects/Requests-List.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.Projects Requests"),
        },
    },
    {
        path: "documents-requests",
        name: "documents-requests",
        
        component: () => import("@views/documents/Requests-List.vue"),
        meta: {
            requiresAuth: true,
            // transition: 'bounce',
            title: t("sidebar.Documents Requests"),
        },
    },


    {
        path: "notifications",
        name: "notifications",
        component: () => import("@views/Notifications.vue"),
        meta: {
            requiresAuth: true,
            title: t("Notifications"),
        },
    },
    {
        path: "preview/:id?",
        name: "docs.preview",
        component: () => import("@views/DocPreview.vue"),
        meta: {
            requiresAuth: true,
            title: t("Doc preview"),
        },
    },
    
];
